import React from 'react';
import {
  ChartWidgetApiContext,
  type ChartWidgetApiContextValue,
} from './Context';

type ChartWidgetApiProviderProps = {
  children: React.ReactNode;
  value: ChartWidgetApiContextValue;
};

export const ChartWidgetApiProvider: React.FC<ChartWidgetApiProviderProps> = ({
  children,
  value,
}) => {

  return (
    <ChartWidgetApiContext.Provider value={value}>
      {children}
    </ChartWidgetApiContext.Provider>
  );
};

export default ChartWidgetApiProvider;